import React, { memo, useEffect } from "react";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { QuestionnaireTableQuestion, QuestionnaireTableAnswer } from "../QuestionnaireTableField";
import { RadioGroup, Radio } from "../../../../BP2Components";
import { setAnswer } from "../../../../../appRedux/actions/FormsV2";
import { createAnswer } from "../questionnarieTableScripts";

interface ChooseOneFieldProps {
   question: QuestionnaireTableQuestion;
   formUuid: number;
}

const ChooseOneField: React.FC<ChooseOneFieldProps> = ({ question, formUuid }) => {
   const { questionnaireTableAnswers } = useSelector(
      (state: RootStateOrAny) => state.formsv2.formInfo[formUuid],
   );
   const dispatch = useDispatch();

   useEffect(() => {
      if (questionnaireTableAnswers[question.questionId] === undefined)
         dispatch(setAnswer(createAnswer(question), formUuid));
   }, []);

   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(
         setAnswer(
            createAnswer(question, {
               answer: e.target.value,
               received_points: e.target.value === question.correctAnswer ? question.maxPoints : 0,
            }),
            formUuid,
         ),
      );
   };

   return (
      <div className="questionnaire-field__container choose-one-field__container">
         <p className="p1 questionnaire-field__title">{question.content}</p>
         <RadioGroup
            name={question.questionId.toString()}
            className="choose-one-field__options"
            onChange={handleChange}
            defaultValue={questionnaireTableAnswers[question.questionId]?.answer || null}
         >
            {question.options?.map((option, index) => (
               <Radio
                  key={`${question.questionId}-${index}`}
                  value={option}
                  id={`${question.questionId}-${index}`}
               >
                  {option}
               </Radio>
            ))}
         </RadioGroup>
      </div>
   );
};

export default memo(ChooseOneField);
